import React from 'react';
import { CircularProgress } from '@mui/material';

import { type FilesViewerProps } from '../FilesViewer';
import useSettings from '../../hooks/useSettings';

/** This component can play video files */
export default function VideoViewer({ fileEncoded, fileType }: FilesViewerProps) {
	const { t } = useSettings();

	const [isLoading, setIsLoading] = React.useState(false);

	function handleCanPlay() {
		setIsLoading(false);
	}

	return isLoading ? (
		<CircularProgress disableShrink />
	) : (
		<video className="w-full" controls controlsList="nodownload" onCanPlay={handleCanPlay}>
			<source src={`data:video/${fileType};base64,${fileEncoded}`} type={`video/${fileType}`} />
			{t('ERROR_FILE_VIDEO_NOT_SUPPORTED')}
		</video>
	);
}
